export const PHONE_TYPES = ['MOBILE', 'HOME', 'WORK'];
